import { defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import get from 'lodash.get';
import Global from '../../../store/global-selectors';
import { CustomsDeclarations } from '../../../containers/bulk-update/bulk-update-actions/customs-declarations';
import { ApplyShippingPreset } from '../../../containers/bulk-update/bulk-update-actions/apply-shipping-preset';
import { OtherShippingOptions } from '../../../containers/bulk-update/bulk-update-actions/other-shipping-options';
import { AdjustWeight } from '../../../containers/bulk-update/bulk-update-actions/adjust-weight';
import { CustomField1 } from '../../../containers/bulk-update/bulk-update-actions/custom-field-1';
import { CustomField2 } from '../../../containers/bulk-update/bulk-update-actions/custom-field-2';
import { CustomField3 } from '../../../containers/bulk-update/bulk-update-actions/custom-field-3';
import { Insurance } from '../../../containers/bulk-update/bulk-update-actions/insurance';
import { Service } from '../../../containers/bulk-update/bulk-update-actions/service';
import { ShipFrom } from '../../../containers/bulk-update/bulk-update-actions/ship-from';
import { PackageBulkAction } from '../../../containers/bulk-update/bulk-update-actions/package-bulk-action';
import { PackingSlipTemplate } from '../../../containers/bulk-update/bulk-update-actions/packing-slip-template';
import { Confirmation } from '../../../containers/bulk-update/bulk-update-actions/confirmation';
import { DoNotNotifyMarketplace } from '../../../containers/bulk-update/bulk-update-actions/do-not-notify-marketplace';
import { Size } from '../../../containers/bulk-update/bulk-update-actions/size';
import { EmailTemplate } from '../../../containers/bulk-update/bulk-update-actions/email-template';
import { DutiesAndTaxes } from '../../../containers/bulk-update/bulk-update-actions/duties-and-taxes';
import { BaseBulkUpdateMenuContainer } from '../../../containers/bulk-update/base-bulk-update-menu-container';
import { BulkActionDataType } from '../../../enums/bulk-action-data-type';

const messages = defineMessages({
  shipment: {
    description: 'shipmentBulkActions.shipment',
    defaultMessage: 'Shipment',
    id: 'pH4uP3',
  },
});

const actions = [
  ApplyShippingPreset,
  Service,
  PackageBulkAction,
  AdjustWeight,
  CustomField1,
  CustomField2,
  CustomField3,
  Size,
  ShipFrom,
  Insurance,
  Confirmation,
  DoNotNotifyMarketplace,
  EmailTemplate,
  PackingSlipTemplate,
  OtherShippingOptions,
  CustomsDeclarations,
];

const actionSections = [{ sectionName: messages.shipment, actions }];

const shouldDisable = (state, props) => {
  const currentBatch = Global.selectBatchDetailsBatch(state);
  const batchUserId = get(currentBatch, 'assignedToGuid');
  const currentUserId = Global.selectUserCurrentUserId(state);
  return props.disabled || batchUserId !== currentUserId;
};

// TODO: need a new ordersShipmentModeBatchDetails.name to replace BulkActionDataType.BATCH_DETAILS
// TODO: we probably broke full batch vs view selection at some point in one or more places
const mapStateToProps = (state, props) => {
  if (!actions.includes(DutiesAndTaxes)) {
    actions.push(DutiesAndTaxes);
  }

  return {
    disabled: shouldDisable(state, props),
    idsSelector: Global.selectSelectedOrdersIds,
    actionSections,
    dataTypeKey: BulkActionDataType.BATCH_DETAILS,
  };
};

export const OrdersBatchesContainer = connect(mapStateToProps)(BaseBulkUpdateMenuContainer);
